import { useMutation } from "@tanstack/react-query";
import { getProgress } from "../../queries/ScheduleHub";

interface IGetHubProgressParams {
  idCronograma: string;
  period: 'week' | 'month' | 'general';
} 

export const useGetHubProgress = () => {
  const { data, isPending, isError, mutate } = useMutation({
    mutationKey: ['getHubProgress'],
    mutationFn: (params: IGetHubProgressParams) => getProgress(params.idCronograma, params.period),
    retry: false,
  });

  return { mutate, isPending, isError, data };
};